// Autoria das alterações no log de auditoria (api_audit_log).
//
// Até 02/10/2026 o backend não sabia QUEM mudava etapa, funil ou dono de um lead: as telas mandavam
// só fone/time/etapa (medido em 7 dias: 1.265 mover_lead_funil_etapa e 1.049 atualizaretapa com
// usuário vazio; na transferência o log gravava o NOVO DONO no lugar de quem transferiu).
//
// Em vez de mexer nas ~20 chamadas espalhadas pelas telas (e esquecer as próximas), toda requisição
// para a NOSSA API leva o usuário logado no cabeçalho `X-Operador-Id`. O backend grava esse valor como
// autor no `api_audit_log`. Destinos externos (Meta, Supabase, uazapi...) não recebem o cabeçalho:
// um cabeçalho custom força preflight de CORS e quebraria chamadas que hoje funcionam.
import { API_URL } from "../environment";

const CABECALHO = "X-Operador-Id";

function urlDe(input: RequestInfo | URL): string {
  if (typeof input === "string") return input;
  if (input instanceof URL) return input.href;
  return input.url;
}

function ehNossaApi(url: string): boolean {
  const base = (API_URL || "").replace(/\/+$/, "");
  if (base && url.startsWith(base)) return true;
  // Em produção API_URL é relativo ("/api"); cobre também a forma absoluta do mesmo host.
  try {
    const u = new URL(url, window.location.origin);
    return u.origin === window.location.origin && u.pathname.startsWith("/api/");
  } catch {
    return false;
  }
}

function operadorAtual(): string | null {
  try {
    const v = localStorage.getItem("id_user");
    return v && v !== "null" && v !== "undefined" ? v : null;
  } catch {
    return null;
  }
}

export function instalarOperadorNoFetch(): void {
  const w = window as Window & { __operadorFetchInstalado?: boolean };
  if (w.__operadorFetchInstalado || typeof window.fetch !== "function") return;
  w.__operadorFetchInstalado = true;
  const original = window.fetch.bind(window);

  window.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const operador = operadorAtual();
    if (!operador || !ehNossaApi(urlDe(input))) return original(input, init);
    // Request já montado: copia os cabeçalhos dele para não perdê-los.
    const base = init?.headers ?? (input instanceof Request ? input.headers : undefined);
    const headers = new Headers(base);
    if (!headers.has(CABECALHO)) headers.set(CABECALHO, operador);
    return original(input, { ...init, headers });
  };
}
